module.exports = __webpack_public_path__ + "static/media/imgEvent.fc659327.png";